import type { ProductFlyer, StoreTemplate } from '@avrahami/contracts';
import { FLYER_TYPES } from './fonts';
import { W, type FlyerImages, type Page } from './kit';
import { drawAtelier } from './templates/atelier';
import { drawDepot } from './templates/depot';
import { drawFresh } from './templates/fresh';
import { drawPanorama } from './templates/panorama';
import { drawPlanner } from './templates/planner';

/**
 * Draws a product's flyer (docs/FLYERS.md, adr/0053) on a square canvas: the flyer of the store's
 * template, in the store's colours, type, corners and logo, with the store's texts of the
 * product. A store that changes its template gets the new template's flyers at once.
 */

export { FLYER_SIZE, type FlyerImage, type FlyerImages } from './kit';

const TEMPLATES: Readonly<Record<StoreTemplate, (page: Page) => void>> = {
  PANORAMA: drawPanorama,
  ATELIER: drawAtelier,
  DEPOT: drawDepot,
  FRESH: drawFresh,
  PLANNER: drawPlanner,
};

/** Draws the whole flyer on a canvas of `FLYER_SIZE` square. */
export function drawFlyer(
  ctx: CanvasRenderingContext2D,
  flyer: ProductFlyer,
  images: FlyerImages,
): void {
  ctx.save();
  ctx.clearRect(0, 0, W, W);
  TEMPLATES[flyer.storeDesign.template]({
    ctx,
    flyer,
    type: FLYER_TYPES[flyer.storeDesign.typeface],
    images,
  });
  ctx.restore();
}
